import ThreeDotsLoader from 'app/components/ThreeDotsLoader'

import Styles from './loadingMessages.module.scss'

function LoadingMessagesFallback() {
  return (
    <div className={Styles.loading_messages_fallback}>
      <ThreeDotsLoader />
    </div>
  )
}

export default LoadingMessagesFallback
